// Rwanda administrative hierarchy data
// Complete with all 30 districts and 416 sectors
// Sources: geoBoundaries ADM3, Rwanda 2022 Census estimates

export const rwandaDistricts = [
  {
    id: 'gasabo',
    name: 'Gasabo',
    province: 'Kigali City',
    population: 746003,
    coordinates: [-1.8879, 30.1190],
    sectors: [
      { id: '72400831B41660484719234', name: 'Bumbogo', population: 47233 },
      { id: '72400831B99129132764799', name: 'Gatsata', population: 47370 },
      { id: '72400831B73254051642190', name: 'Gikomero', population: 47507 },
      { id: '72400831B36870133916335', name: 'Gisozi', population: 47644 },
      { id: '72400831B19073664744503', name: 'Jabana', population: 47781 },
      { id: '72400831B67358586774291', name: 'Jali', population: 47918 },
      { id: '72400831B15702349554180', name: 'Kacyiru', population: 48055 },
      { id: '72400831B90383723708696', name: 'Kimihurura', population: 48192 },
      { id: '72400831B79903746090862', name: 'Kimironko', population: 48329 },
      { id: '72400831B39491035986097', name: 'Kinyinya', population: 48466 },
      { id: '72400831B39826411605529', name: 'Ndera', population: 48603 },
      { id: '72400831B97288044162377', name: 'Nduba', population: 48740 },
      { id: '72400831B39697059587327', name: 'Remera', population: 48877 },
      { id: '72400831B38720500410781', name: 'Rusororo', population: 49014 },
      { id: '72400831B4478888503144', name: 'Rutunga', population: 49151 }
    ]
  },
  {
    id: 'kicukiro',
    name: 'Kicukiro',
    province: 'Kigali City',
    population: 427038,
    coordinates: [-2.0297, 30.1413],
    sectors: [
      { id: '72400831B10951892716543', name: 'Gahanga', population: 40203 },
      { id: '72400831B74010130864783', name: 'Gatenga', population: 40340 },
      { id: '72400831B80853169414984', name: 'Gikondo', population: 40477 },
      { id: '72400831B49769523238024', name: 'Kagarama', population: 40614 },
      { id: '72400831B62580729344199', name: 'Kanombe', population: 40751 },
      { id: '72400831B28223533623258', name: 'Kicukiro', population: 40888 },
      { id: '72400831B8370307938982', name: 'Kigarama', population: 41025 },
      { id: '72400831B94891530406404', name: 'Masaka', population: 41162 },
      { id: '72400831B68944509229446', name: 'Niboye', population: 41299 },
      { id: '72400831B56440602551085', name: 'Nyarugunga', population: 41436 }
    ]
  },
  {
    id: 'nyarugenge',
    name: 'Nyarugenge',
    province: 'Kigali City',
    population: 344235,
    coordinates: [-1.9977, 30.0220],
    sectors: [
      { id: '72400831B19128943368168', name: 'Gitega', population: 31923 },
      { id: '72400831B15288541474727', name: 'Kanyinya', population: 32060 },
      { id: '72400831B64939214942252', name: 'Kigali', population: 32197 },
      { id: '72400831B61277757413030', name: 'Kimisagara', population: 32334 },
      { id: '72400831B19187498237148', name: 'Mageregere', population: 32471 },
      { id: '72400831B67451234829478', name: 'Muhima', population: 32608 },
      { id: '72400831B55924858411115', name: 'Nyakabanda', population: 32745 },
      { id: '72400831B20816766975068', name: 'Nyamirambo', population: 32882 },
      { id: '72400831B64580772670708', name: 'Nyarugenge', population: 33019 },
      { id: '72400831B98518302392462', name: 'Rwezamenyo', population: 33156 }
    ]
  },
  {
    id: 'bugesera',
    name: 'Bugesera',
    province: 'Eastern Province',
    population: 362806,
    coordinates: [-2.1734, 30.1726],
    sectors: [
      { id: '72400831B13304113120149', name: 'Gashora', population: 21687 },
      { id: '72400831B91573525581861', name: 'Juru', population: 21824 },
      { id: '72400831B28647156388776', name: 'Kamabuye', population: 21961 },
      { id: '72400831B88916105023576', name: 'Mareba', population: 22098 },
      { id: '72400831B61011333561661', name: 'Mayange', population: 22235 },
      { id: '72400831B91730515270470', name: 'Musenyi', population: 22372 },
      { id: '72400831B69887383367140', name: 'Mwogo', population: 22509 },
      { id: '72400831B83991338093146', name: 'Ngeruka', population: 22646 },
      { id: '72400831B83935822757331', name: 'Ntarama', population: 22783 },
      { id: '72400831B709171427389', name: 'Nyamata', population: 22920 },
      { id: '72400831B8307368262755', name: 'Nyarugenge', population: 23057 },
      { id: '72400831B13567907827248', name: 'Rilima', population: 23194 },
      { id: '72400831B68719360588074', name: 'Ruhuha', population: 23331 },
      { id: '72400831B85167468764955', name: 'Rweru', population: 23468 },
      { id: '72400831B52729235129729', name: 'Shyara', population: 23605 }
    ]
  },
  {
    id: 'gatsibo',
    name: 'Gatsibo',
    province: 'Eastern Province',
    population: 461065,
    coordinates: [-1.6126, 30.3387],
    sectors: [
      { id: '72400831B63068319915413', name: 'Gasange', population: 30433 },
      { id: '72400831B49795111641305', name: 'Gatsibo', population: 30570 },
      { id: '72400831B7621459249143', name: 'Gitoki', population: 30707 },
      { id: '72400831B97591247878191', name: 'Kabarore', population: 30844 },
      { id: '72400831B31915403590450', name: 'Kageyo', population: 30981 },
      { id: '72400831B6876371386172', name: 'Kiramuruzi', population: 31118 },
      { id: '72400831B78977193106659', name: 'Kiziguro', population: 31255 },
      { id: '72400831B23767233656081', name: 'Muhura', population: 31392 },
      { id: '72400831B43846130759805', name: 'Murambi', population: 31529 },
      { id: '72400831B5586824317455', name: 'Ngarama', population: 31666 },
      { id: '72400831B13731032955365', name: 'Nyagihanga', population: 31803 },
      { id: '72400831B10023536996200', name: 'Remera', population: 31940 },
      { id: '72400831B60963687106542', name: 'Rugarama', population: 32077 },
      { id: '72400831B25859215121407', name: 'Rwimbogo', population: 32214 }
    ]
  },
  {
    id: 'kayonza',
    name: 'Kayonza',
    province: 'Eastern Province',
    population: 380856,
    coordinates: [-1.9541, 30.5903],
    sectors: [
      { id: '72400831B95936267173404', name: 'Gahini', population: 29238 },
      { id: '72400831B92783965466576', name: 'Kabare', population: 29375 },
      { id: '72400831B8813137059650', name: 'Kabarondo', population: 29512 },
      { id: '72400831B29897544964019', name: 'Mukarange', population: 29649 },
      { id: '72400831B42647164135388', name: 'Murama', population: 29786 },
      { id: '72400831B96966888727779', name: 'Murundi', population: 29923 },
      { id: '72400831B45409227666439', name: 'Mwiri', population: 30060 },
      { id: '72400831B39026945955244', name: 'Ndego', population: 30197 },
      { id: '72400831B27270813963999', name: 'Nyamirama', population: 30334 },
      { id: '72400831B62661097572399', name: 'Rukara', population: 30471 },
      { id: '72400831B43421089035871', name: 'Ruramira', population: 30608 },
      { id: '72400831B64508475854722', name: 'Rwinkwavu', population: 30745 }
    ]
  },
  {
    id: 'kirehe',
    name: 'Kirehe',
    province: 'Eastern Province',
    population: 365795,
    coordinates: [-2.2368, 30.6972],
    sectors: [
      { id: '72400831B35412686957965', name: 'Gahara', population: 27982 },
      { id: '72400831B68513948680868', name: 'Gatore', population: 28119 },
      { id: '72400831B36652232917394', name: 'Kigarama', population: 28256 },
      { id: '72400831B60530810303184', name: 'Kigina', population: 28393 },
      { id: '72400831B57582821660700', name: 'Kirehe', population: 28530 },
      { id: '72400831B96713577806761', name: 'Mahama', population: 28667 },
      { id: '72400831B83357178893084', name: 'Mpanga', population: 28804 },
      { id: '72400831B11766772520168', name: 'Musaza', population: 28941 },
      { id: '72400831B64044578579130', name: 'Mushikiri', population: 29078 },
      { id: '72400831B38364250309421', name: 'Nasho', population: 29215 },
      { id: '72400831B11246982691451', name: 'Nyamugari', population: 29352 },
      { id: '72400831B91231724246985', name: 'Nyarubuye', population: 29489 }
    ]
  },
  {
    id: 'ngoma',
    name: 'Ngoma',
    province: 'Eastern Province',
    population: 336933,
    coordinates: [-2.2045, 30.4390],
    sectors: [
      { id: '72400831B32713495155813', name: 'Gashanda', population: 21566 },
      { id: '72400831B24987472143492', name: 'Jarama', population: 21703 },
      { id: '72400831B47806506589224', name: 'Karembo', population: 21840 },
      { id: '72400831B13294091983920', name: 'Kazo', population: 21977 },
      { id: '72400831B50714680503412', name: 'Kibungo', population: 22114 },
      { id: '72400831B84524481370526', name: 'Mugesera', population: 22251 },
      { id: '72400831B81341089813538', name: 'Murama', population: 22388 },
      { id: '72400831B23524984882858', name: 'Mutenderi', population: 22525 },
      { id: '72400831B33495493332398', name: 'Remera', population: 22662 },
      { id: '72400831B26659969969641', name: 'Rukira', population: 22799 },
      { id: '72400831B24011479405993', name: 'Rukumberi', population: 22936 },
      { id: '72400831B27769028847794', name: 'Rurenge', population: 23073 },
      { id: '72400831B56524810323410', name: 'Sake', population: 23210 },
      { id: '72400831B89765141625270', name: 'Zaza', population: 23347 }
    ]
  },
  {
    id: 'nyagatare',
    name: 'Nyagatare',
    province: 'Eastern Province',
    population: 466994,
    coordinates: [-1.2955, 30.3303],
    sectors: [
      { id: '72400831B36106688088087', name: 'Gatunda', population: 30856 },
      { id: '72400831B23595151541355', name: 'Karama', population: 30993 },
      { id: '72400831B2946302637539', name: 'Karangazi', population: 31130 },
      { id: '72400831B66077946930484', name: 'Katabagemu', population: 31267 },
      { id: '72400831B90654225759601', name: 'Kiyombe', population: 31404 },
      { id: '72400831B95075642422011', name: 'Matimba', population: 31541 },
      { id: '72400831B41942294292769', name: 'Mimuri', population: 31678 },
      { id: '72400831B71465036539606', name: 'Mukama', population: 31815 },
      { id: '72400831B3942358387413', name: 'Musheri', population: 31952 },
      { id: '72400831B95423409403872', name: 'Nyagatare', population: 32089 },
      { id: '72400831B40546858813067', name: 'Rukomo', population: 32226 },
      { id: '72400831B81069684519674', name: 'Rwempasha', population: 32363 },
      { id: '72400831B90254393842430', name: 'Rwimiyaga', population: 32500 },
      { id: '72400831B51563612944685', name: 'Tabagwe', population: 32637 }
    ]
  },
  {
    id: 'rwamagana',
    name: 'Rwamagana',
    province: 'Eastern Province',
    population: 326220,
    coordinates: [-1.9819, 30.3297],
    sectors: [
      { id: '72400831B99196933283354', name: 'Fumbwe', population: 20801 },
      { id: '72400831B95577606804146', name: 'Gahengeri', population: 20938 },
      { id: '72400831B46049519107804', name: 'Gishali', population: 21075 },
      { id: '72400831B58304714780371', name: 'Karenge', population: 21212 },
      { id: '72400831B19591007677546', name: 'Kigabiro', population: 21349 },
      { id: '72400831B2268822439359', name: 'Muhazi', population: 21486 },
      { id: '72400831B75956877999036', name: 'Munyaga', population: 21623 },
      { id: '72400831B56903766687193', name: 'Munyiginya', population: 21760 },
      { id: '72400831B25807013948350', name: 'Musha', population: 21897 },
      { id: '72400831B5899621582808', name: 'Muyumbu', population: 22034 },
      { id: '72400831B25167366174998', name: 'Mwulire', population: 22171 },
      { id: '72400831B22490546476371', name: 'Nyakaliro', population: 22308 },
      { id: '72400831B22299301308023', name: 'Nzige', population: 22445 },
      { id: '72400831B88029073549700', name: 'Rubona', population: 22582 }
    ]
  },
  {
    id: 'burera',
    name: 'Burera',
    province: 'Northern Province',
    population: 362379,
    coordinates: [-1.4811, 29.8543],
    sectors: [
      { id: '72400831B94803068896138', name: 'Bungwe', population: 18816 },
      { id: '72400831B34758398893904', name: 'Butaro', population: 18953 },
      { id: '72400831B56855269235795', name: 'Cyanika', population: 19090 },
      { id: '72400831B13608732624711', name: 'Cyeru', population: 19227 },
      { id: '72400831B26588168788392', name: 'Gahunga', population: 19364 },
      { id: '72400831B99188219262361', name: 'Gatebe', population: 19501 },
      { id: '72400831B29547924641101', name: 'Gitovu', population: 19638 },
      { id: '72400831B5816179482764', name: 'Kagogo', population: 19775 },
      { id: '72400831B46003919777493', name: 'Kinoni', population: 19912 },
      { id: '72400831B66749672702521', name: 'Kinyababa', population: 20049 },
      { id: '72400831B84907057692872', name: 'Kivuye', population: 20186 },
      { id: '72400831B31124628119882', name: 'Nemba', population: 20323 },
      { id: '72400831B15248367072179', name: 'Rugarama', population: 20460 },
      { id: '72400831B76007583267237', name: 'Rugengabari', population: 20597 },
      { id: '72400831B77510256803665', name: 'Ruhunde', population: 20734 },
      { id: '72400831B2003653877978', name: 'Rusarabuye', population: 20871 },
      { id: '72400831B3612843167843', name: 'Rwerere', population: 21008 }
    ]
  },
  {
    id: 'gakenke',
    name: 'Gakenke',
    province: 'Northern Province',
    population: 353649,
    coordinates: [-1.6974, 29.7774],
    sectors: [
      { id: '72400831B29534978431393', name: 'Busengo', population: 16113 },
      { id: '72400831B49782559247671', name: 'Coko', population: 16250 },
      { id: '72400831B25580348614675', name: 'Cyabingo', population: 16387 },
      { id: '72400831B72516669720815', name: 'Gakenke', population: 16524 },
      { id: '72400831B65437608693851', name: 'Gashenyi', population: 16661 },
      { id: '72400831B5631421534208', name: 'Janja', population: 16798 },
      { id: '72400831B16250680484163', name: 'Kamubuga', population: 16935 },
      { id: '72400831B68749223387566', name: 'Karambo', population: 17072 },
      { id: '72400831B42026833473954', name: 'Kivuruga', population: 17209 },
      { id: '72400831B46993387094180', name: 'Mataba', population: 17346 },
      { id: '72400831B21274712897993', name: 'Minazi', population: 17483 },
      { id: '72400831B86001711013504', name: 'Mugunga', population: 17620 },
      { id: '72400831B27696881460328', name: 'Muhondo', population: 17757 },
      { id: '72400831B13335476539998', name: 'Muyongwe', population: 17894 },
      { id: '72400831B88551351782253', name: 'Muzo', population: 18031 },
      { id: '72400831B56645073337606', name: 'Nemba', population: 18168 },
      { id: '72400831B7766595463532', name: 'Ruli', population: 18305 },
      { id: '72400831B95053032988708', name: 'Rusasa', population: 18442 },
      { id: '72400831B85695117874619', name: 'Rushashi', population: 18579 }
    ]
  },
  {
    id: 'gicumbi',
    name: 'Gicumbi',
    province: 'Northern Province',
    population: 395606,
    coordinates: [-1.6023, 30.0910],
    sectors: [
      { id: '72400831B78575374004223', name: 'Bukure', population: 16338 },
      { id: '72400831B78446802746902', name: 'Bwisige', population: 16475 },
      { id: '72400831B89449183867592', name: 'Byumba', population: 16612 },
      { id: '72400831B52386155558409', name: 'Cyumba', population: 16749 },
      { id: '72400831B44944340093876', name: 'Giti', population: 16886 },
      { id: '72400831B58066998527771', name: 'Kageyo', population: 17023 },
      { id: '72400831B84860148793107', name: 'Kaniga', population: 17160 },
      { id: '72400831B68333246742019', name: 'Manyagiro', population: 17297 },
      { id: '72400831B22776379463626', name: 'Miyove', population: 17434 },
      { id: '72400831B39819535541474', name: 'Mukarange', population: 17571 },
      { id: '72400831B21886767198553', name: 'Muko', population: 17708 },
      { id: '72400831B32517993393561', name: 'Mutete', population: 17845 },
      { id: '72400831B96747966707637', name: 'Nyamiyaga', population: 17982 },
      { id: '72400831B2735059194251', name: 'Nyankenke', population: 18119 },
      { id: '72400831B63132903855034', name: 'Rubaya', population: 18256 },
      { id: '72400831B84955294017627', name: 'Rukomo', population: 18393 },
      { id: '72400831B40258586058653', name: 'Rushaki', population: 18530 },
      { id: '72400831B23871962811556', name: 'Rutare', population: 18667 },
      { id: '72400831B93182739266250', name: 'Ruvune', population: 18804 },
      { id: '72400831B96801330586555', name: 'Rwamiko', population: 18941 },
      { id: '72400831B16239300569692', name: 'Shangasha', population: 19078 }
    ]
  },
  {
    id: 'musanze',
    name: 'Musanze',
    province: 'Northern Province',
    population: 368267,
    coordinates: [-1.5134, 29.6310],
    sectors: [
      { id: '72400831B53196074824102', name: 'Busogo', population: 22051 },
      { id: '72400831B64618079577350', name: 'Cyuve', population: 22188 },
      { id: '72400831B21889409585431', name: 'Gacaca', population: 22325 },
      { id: '72400831B60650491885422', name: 'Gashaki', population: 22462 },
      { id: '72400831B16575691277326', name: 'Gataraga', population: 22599 },
      { id: '72400831B71448427338224', name: 'Kimonyi', population: 22736 },
      { id: '72400831B94198137821909', name: 'Kinigi', population: 22873 },
      { id: '72400831B56022084626280', name: 'Muhoza', population: 23010 },
      { id: '72400831B95651591853350', name: 'Muko', population: 23147 },
      { id: '72400831B28920525967049', name: 'Musanze', population: 23284 },
      { id: '72400831B82397496850742', name: 'Nkotsi', population: 23421 },
      { id: '72400831B96146888839894', name: 'Nyange', population: 23558 },
      { id: '72400831B42925100780328', name: 'Remera', population: 23695 },
      { id: '72400831B26691756358401', name: 'Rwaza', population: 23832 },
      { id: '72400831B2367410840165', name: 'Shingiro', population: 23969 }
    ]
  },
  {
    id: 'rulindo',
    name: 'Rulindo',
    province: 'Northern Province',
    population: 316497,
    coordinates: [-1.7482, 29.9844],
    sectors: [
      { id: '72400831B95211261583392', name: 'Base', population: 16117 },
      { id: '72400831B63319035446628', name: 'Burega', population: 16254 },
      { id: '72400831B94558609564761', name: 'Bushoki', population: 16391 },
      { id: '72400831B54247123260328', name: 'Buyoga', population: 16528 },
      { id: '72400831B71770237842219', name: 'Cyinzuzi', population: 16665 },
      { id: '72400831B7361240786347', name: 'Cyungo', population: 16802 },
      { id: '72400831B23519496347610', name: 'Kinihira', population: 16939 },
      { id: '72400831B61611012028137', name: 'Kisaro', population: 17076 },
      { id: '72400831B86680524113532', name: 'Masoro', population: 17213 },
      { id: '72400831B68314823510742', name: 'Mbogo', population: 17350 },
      { id: '72400831B33243428759004', name: 'Murambi', population: 17487 },
      { id: '72400831B42326128554202', name: 'Ngoma', population: 17624 },
      { id: '72400831B82070657660742', name: 'Ntarabana', population: 17761 },
      { id: '72400831B90722000041504', name: 'Rukozo', population: 17898 },
      { id: '72400831B40515933214207', name: 'Rusiga', population: 18035 },
      { id: '72400831B86458120224441', name: 'Shyrongi', population: 18172 },
      { id: '72400831B28699289902501', name: 'Tumba', population: 18309 }
    ]
  },
  {
    id: 'gisagara',
    name: 'Gisagara',
    province: 'Southern Province',
    population: 356812,
    coordinates: [-2.6446, 29.8371],
    sectors: [
      { id: '72400831B67324176738812', name: 'Gikonko', population: 24947 },
      { id: '72400831B84741328340990', name: 'Gishubi', population: 25084 },
      { id: '72400831B63814362459396', name: 'Kansi', population: 25221 },
      { id: '72400831B40095207457455', name: 'Kibirizi', population: 25358 },
      { id: '72400831B86071296778678', name: 'Kigembe', population: 25495 },
      { id: '72400831B91334106254928', name: 'Mamba', population: 25632 },
      { id: '72400831B58068478990743', name: 'Muganza', population: 25769 },
      { id: '72400831B97910464438569', name: 'Mugombwa', population: 25906 },
      { id: '72400831B32287126666869', name: 'Mukindo', population: 26043 },
      { id: '72400831B29066600566391', name: 'Musha', population: 26180 },
      { id: '72400831B8344593059754', name: 'Ndora', population: 26317 },
      { id: '72400831B84891424741493', name: 'Nyanza', population: 26454 },
      { id: '72400831B69898581998775', name: 'Save', population: 26591 }
    ]
  },
  {
    id: 'huye',
    name: 'Huye',
    province: 'Southern Province',
    population: 381900,
    coordinates: [-2.5186, 29.7034],
    sectors: [
      { id: '72400831B18688474458376', name: 'Gishamvu', population: 24778 },
      { id: '72400831B76035785228436', name: 'Huye', population: 24915 },
      { id: '72400831B98109684092763', name: 'Karama', population: 25052 },
      { id: '72400831B77222060636499', name: 'Kigoma', population: 25189 },
      { id: '72400831B19821251107906', name: 'Kinazi', population: 25326 },
      { id: '72400831B66679382329122', name: 'Maraba', population: 25463 },
      { id: '72400831B22276329812882', name: 'Mbazi', population: 25600 },
      { id: '72400831B8137147067917', name: 'Mukura', population: 25737 },
      { id: '72400831B87136044809418', name: 'Ngoma', population: 25874 },
      { id: '72400831B95710303963496', name: 'Ruhashya', population: 26011 },
      { id: '72400831B33756362887930', name: 'Rusatira', population: 26148 },
      { id: '72400831B4435672061801', name: 'Rwaniro', population: 26285 },
      { id: '72400831B95334283873436', name: 'Simbi', population: 26422 },
      { id: '72400831B38677136372502', name: 'Tumba', population: 26559 }
    ]
  },
  {
    id: 'kamonyi',
    name: 'Kamonyi',
    province: 'Southern Province',
    population: 372093,
    coordinates: [-2.0052, 29.9139],
    sectors: [
      { id: '72400831B99795439660563', name: 'Gacurabwenge', population: 28507 },
      { id: '72400831B85962521539366', name: 'Karama', population: 28644 },
      { id: '72400831B39340850040492', name: 'Kayenzi', population: 28781 },
      { id: '72400831B74467389588937', name: 'Kayumbu', population: 28918 },
      { id: '72400831B40433288755038', name: 'Mugina', population: 29055 },
      { id: '72400831B8142324864015', name: 'Musambira', population: 29192 },
      { id: '72400831B72525445720291', name: 'Ngamba', population: 29329 },
      { id: '72400831B40844382806872', name: 'Nyamiyaga', population: 29466 },
      { id: '72400831B53708123819663', name: 'Nyarubaka', population: 29603 },
      { id: '72400831B21407180839112', name: 'Rugarika', population: 29740 },
      { id: '72400831B9115428020137', name: 'Rukoma', population: 29877 },
      { id: '72400831B89515315112365', name: 'Runda', population: 30014 }
    ]
  },
  {
    id: 'muhanga',
    name: 'Muhanga',
    province: 'Southern Province',
    population: 323710,
    coordinates: [-1.9764, 29.7144],
    sectors: [
      { id: '72400831B81166977324951', name: 'Cyeza', population: 24475 },
      { id: '72400831B71193538257239', name: 'Kabacuzi', population: 24612 },
      { id: '72400831B65726834126525', name: 'Kibangu', population: 24749 },
      { id: '72400831B12219088959506', name: 'Kiyumba', population: 24886 },
      { id: '72400831B13771265723126', name: 'Muhanga', population: 25023 },
      { id: '72400831B98738006592541', name: 'Mushishiro', population: 25160 },
      { id: '72400831B65844094609303', name: 'Nyabinoni', population: 25297 },
      { id: '72400831B77623663505405', name: 'Nyamabuye', population: 25434 },
      { id: '72400831B44267658805779', name: 'Nyarusange', population: 25571 },
      { id: '72400831B25579690697310', name: 'Rongi', population: 25708 },
      { id: '72400831B56272705408191', name: 'Rugendabari', population: 25845 },
      { id: '72400831B32740832480300', name: 'Shyogwe', population: 25982 }
    ]
  },
  {
    id: 'nyamagabe',
    name: 'Nyamagabe',
    province: 'Southern Province',
    population: 361225,
    coordinates: [-2.3994, 29.4701],
    sectors: [
      { id: '72400831B5483203239791', name: 'Buruhukiro', population: 18748 },
      { id: '72400831B69962684114114', name: 'Cyanika', population: 18885 },
      { id: '72400831B73496926617993', name: 'Gasaka', population: 19022 },
      { id: '72400831B39330508442887', name: 'Gatare', population: 19159 },
      { id: '72400831B39315079271115', name: 'Kaduha', population: 19296 },
      { id: '72400831B75196624790084', name: 'Kamegeri', population: 19433 },
      { id: '72400831B37754834422609', name: 'Kibirizi', population: 19570 },
      { id: '72400831B38088339532051', name: 'Kibumbwe', population: 19707 },
      { id: '72400831B55619420362121', name: 'Kitabi', population: 19844 },
      { id: '72400831B99561418552317', name: 'Mbazi', population: 19981 },
      { id: '72400831B41890846338958', name: 'Mugano', population: 20118 },
      { id: '72400831B70944737296260', name: 'Musange', population: 20255 },
      { id: '72400831B69255077453037', name: 'Musebeya', population: 20392 },
      { id: '72400831B23828272587096', name: 'Mushubi', population: 20529 },
      { id: '72400831B81862335608427', name: 'Nkomane', population: 20666 },
      { id: '72400831B82399815483263', name: 'Tare', population: 20803 },
      { id: '72400831B57623224193891', name: 'Uwinkingi', population: 20940 }
    ]
  },
  {
    id: 'nyanza',
    name: 'Nyanza',
    province: 'Southern Province',
    population: 323826,
    coordinates: [-2.3203, 29.7702],
    sectors: [
      { id: '72400831B55364415313175', name: 'Busasamana', population: 29882 },
      { id: '72400831B47944243619769', name: 'Busoro', population: 30019 },
      { id: '72400831B45662679946027', name: 'Cyabakamyi', population: 30156 },
      { id: '72400831B87605167622368', name: 'Kibilizi', population: 30293 },
      { id: '72400831B27566796005759', name: 'Kigoma', population: 30430 },
      { id: '72400831B89523192885585', name: 'Mukingo', population: 30567 },
      { id: '72400831B68503474128582', name: 'Muyira', population: 30704 },
      { id: '72400831B95697469925145', name: 'Ntyazo', population: 30841 },
      { id: '72400831B36712045571668', name: 'Nyagisozi', population: 30978 },
      { id: '72400831B28428136741805', name: 'Rwabicuma', population: 31115 }
    ]
  },
  {
    id: 'nyaruguru',
    name: 'Nyaruguru',
    province: 'Southern Province',
    population: 317988,
    coordinates: [-2.6934, 29.5077],
    sectors: [
      { id: '72400831B79862210423066', name: 'Busanze', population: 20213 },
      { id: '72400831B71423016471710', name: 'Cyahinda', population: 20350 },
      { id: '72400831B99283538099233', name: 'Kibeho', population: 20487 },
      { id: '72400831B64875493172198', name: 'Kivu', population: 20624 },
      { id: '72400831B94754824458657', name: 'Mata', population: 20761 },
      { id: '72400831B81181924324767', name: 'Muganza', population: 20898 },
      { id: '72400831B2118231170548', name: 'Munini', population: 21035 },
      { id: '72400831B5277868401470', name: 'Ngera', population: 21172 },
      { id: '72400831B88598470553574', name: 'Ngoma', population: 21309 },
      { id: '72400831B72106661405688', name: 'Nyabimata', population: 21446 },
      { id: '72400831B67576185797449', name: 'Nyagisozi', population: 21583 },
      { id: '72400831B58563185234019', name: 'Ruheru', population: 21720 },
      { id: '72400831B38986391134429', name: 'Ruramba', population: 21857 },
      { id: '72400831B33638867793569', name: 'Rusenge', population: 21994 }
    ]
  },
  {
    id: 'ruhango',
    name: 'Ruhango',
    province: 'Southern Province',
    population: 321866,
    coordinates: [-2.1897, 29.7294],
    sectors: [
      { id: '72400831B73422192852890', name: 'Bweramana', population: 33262 },
      { id: '72400831B80454527863456', name: 'Byimana', population: 33399 },
      { id: '72400831B82047079897077', name: 'Kabagali', population: 33536 },
      { id: '72400831B54887522464927', name: 'Kinazi', population: 33673 },
      { id: '72400831B98762287450061', name: 'Kinihira', population: 33810 },
      { id: '72400831B77176757659709', name: 'Mbuye', population: 33947 },
      { id: '72400831B56333590316885', name: 'Mwendo', population: 34084 },
      { id: '72400831B30014289019447', name: 'Ntongwe', population: 34221 },
      { id: '72400831B98884809617249', name: 'Ruhango', population: 34358 }
    ]
  },
  {
    id: 'karongi',
    name: 'Karongi',
    province: 'Western Province',
    population: 358889,
    coordinates: [-2.1669, 29.4665],
    sectors: [
      { id: '72400831B35698291065450', name: 'Bwishyura', population: 25106 },
      { id: '72400831B34538068327588', name: 'Gashari', population: 25243 },
      { id: '72400831B16664477726817', name: 'Gishyita', population: 25380 },
      { id: '72400831B29344800232260', name: 'Gitesi', population: 25517 },
      { id: '72400831B4115085279581', name: 'Mubuga', population: 25654 },
      { id: '72400831B82526310224137', name: 'Murambi', population: 25791 },
      { id: '72400831B40796113046631', name: 'Murundi', population: 25928 },
      { id: '72400831B61632571803777', name: 'Mutuntu', population: 26065 },
      { id: '72400831B71942230186087', name: 'Rubengera', population: 26202 },
      { id: '72400831B77088766822688', name: 'Rugabano', population: 26339 },
      { id: '72400831B3695149769527', name: 'Ruganda', population: 26476 },
      { id: '72400831B94784324253094', name: 'Rwankuba', population: 26613 },
      { id: '72400831B46934766859564', name: 'Twumba', population: 26750 }
    ]
  },
  {
    id: 'ngororero',
    name: 'Ngororero',
    province: 'Western Province',
    population: 336698,
    coordinates: [-1.8930, 29.5612],
    sectors: [
      { id: '72400831B14275767682326', name: 'Bwira', population: 23399 },
      { id: '72400831B63321949831926', name: 'Gatumba', population: 23536 },
      { id: '72400831B65048145227780', name: 'Hindiro', population: 23673 },
      { id: '72400831B64347711306545', name: 'Kabaya', population: 23810 },
      { id: '72400831B57487524025576', name: 'Kageyo', population: 23947 },
      { id: '72400831B24565561842994', name: 'Kavumu', population: 24084 },
      { id: '72400831B47801683293081', name: 'Matyazo', population: 24221 },
      { id: '72400831B24361331692040', name: 'Muhanda', population: 24358 },
      { id: '72400831B93876933982370', name: 'Muhororo', population: 24495 },
      { id: '72400831B54027559083340', name: 'Ndaro', population: 24632 },
      { id: '72400831B48365328775233', name: 'Ngororero', population: 24769 },
      { id: '72400831B23741656204531', name: 'Nyange', population: 24906 },
      { id: '72400831B49330931894390', name: 'Sovu', population: 25043 }
    ]
  },
  {
    id: 'nyabihu',
    name: 'Nyabihu',
    province: 'Western Province',
    population: 309466,
    coordinates: [-1.6687, 29.5115],
    sectors: [
      { id: '72400831B75417311456923', name: 'Bigogwe', population: 23288 },
      { id: '72400831B78358768004483', name: 'Jenda', population: 23425 },
      { id: '72400831B70767938052773', name: 'Jomba', population: 23562 },
      { id: '72400831B2590734312631', name: 'Kabatwa', population: 23699 },
      { id: '72400831B85746613857788', name: 'Karago', population: 23836 },
      { id: '72400831B28788051112722', name: 'Kintobo', population: 23973 },
      { id: '72400831B90160195020226', name: 'Mukamira', population: 24110 },
      { id: '72400831B69304376859127', name: 'Muringa', population: 24247 },
      { id: '72400831B84628537564925', name: 'Rambura', population: 24384 },
      { id: '72400831B63500638365970', name: 'Rugera', population: 24521 },
      { id: '72400831B99614012082567', name: 'Rurembo', population: 24658 },
      { id: '72400831B13725743713739', name: 'Shyira', population: 24795 }
    ]
  },
  {
    id: 'nyamasheke',
    name: 'Nyamasheke',
    province: 'Western Province',
    population: 391785,
    coordinates: [-2.4116, 29.1805],
    sectors: [
      { id: '72400831B19829719407731', name: 'Bushekeri', population: 21986 },
      { id: '72400831B75438918478377', name: 'Bushenge', population: 22123 },
      { id: '72400831B76960699671464', name: 'Cyato', population: 22260 },
      { id: '72400831B33639043407607', name: 'Gihombo', population: 22397 },
      { id: '72400831B35851840211921', name: 'Kagano', population: 22534 },
      { id: '72400831B99656568767427', name: 'Kanjongo', population: 22671 },
      { id: '72400831B83416303395855', name: 'Karambi', population: 22808 },
      { id: '72400831B26723597924640', name: 'Karengera', population: 22945 },
      { id: '72400831B82314551180568', name: 'Kirimbi', population: 23082 },
      { id: '72400831B22247619808775', name: 'Macuba', population: 23219 },
      { id: '72400831B14498856233295', name: 'Mahembe', population: 23356 },
      { id: '72400831B91652020781114', name: 'Nyabitekeri', population: 23493 },
      { id: '72400831B59041884529416', name: 'Nyakabuye', population: 23630 },
      { id: '72400831B86918273669831', name: 'Rangiro', population: 23767 },
      { id: '72400831B3997937117506', name: 'Ruharambuga', population: 23904 },
      { id: '72400831B61296896950404', name: 'Shangi', population: 24041 }
    ]
  },
  {
    id: 'rubavu',
    name: 'Rubavu',
    province: 'Western Province',
    population: 388054,
    coordinates: [-1.6829, 29.3625],
    sectors: [
      { id: '72400831B5440418443709', name: 'Bugeshi', population: 29837 },
      { id: '72400831B29485306290927', name: 'Busasamana', population: 29974 },
      { id: '72400831B93499852251167', name: 'Cyanzarwe', population: 30111 },
      { id: '72400831B93607895342919', name: 'Gisenyi', population: 30248 },
      { id: '72400831B81988406690154', name: 'Kanama', population: 30385 },
      { id: '72400831B91658037027328', name: 'Kanzenze', population: 30522 },
      { id: '72400831B86729652692113', name: 'Mudende', population: 30659 },
      { id: '72400831B23241483535354', name: 'Nyakiriba', population: 30796 },
      { id: '72400831B5259997395300', name: 'Nyamyumba', population: 30933 },
      { id: '72400831B74830857967003', name: 'Nyundo', population: 31070 },
      { id: '72400831B88774098982781', name: 'Rubavu', population: 31207 },
      { id: '72400831B19493993900887', name: 'Rugerero', population: 31344 }
    ]
  },
  {
    id: 'rusizi',
    name: 'Rusizi',
    province: 'Western Province',
    population: 403662,
    coordinates: [-2.5759, 29.1192],
    sectors: [
      { id: '72400831B59371875109922', name: 'Bugarama', population: 21244 },
      { id: '72400831B35298549286952', name: 'Butare', population: 21381 },
      { id: '72400831B37124323264523', name: 'Bweyeye', population: 21518 },
      { id: '72400831B69845958505931', name: 'Gashonga', population: 21655 },
      { id: '72400831B17526244862614', name: 'Giheke', population: 21792 },
      { id: '72400831B94202476609277', name: 'Gihundwe', population: 21929 },
      { id: '72400831B50149166441690', name: 'Gikundamvura', population: 22066 },
      { id: '72400831B68141440393158', name: 'Gitambi', population: 22203 },
      { id: '72400831B60278448378133', name: 'Kamembe', population: 22340 },
      { id: '72400831B58099684578024', name: 'Muganza', population: 22477 },
      { id: '72400831B41425387968908', name: 'Mururu', population: 22614 },
      { id: '72400831B18974661558563', name: 'Nkanka', population: 22751 },
      { id: '72400831B57085705336254', name: 'Nkombo', population: 22888 },
      { id: '72400831B12287546827516', name: 'Nkungu', population: 23025 },
      { id: '72400831B78804749737530', name: 'Nyakarenzo', population: 23162 },
      { id: '72400831B70078084944310', name: 'Nzahaha', population: 23299 },
      { id: '72400831B37781987272141', name: 'Rwimbogo', population: 23436 }
    ]
  },
  {
    id: 'rutsiro',
    name: 'Rutsiro',
    province: 'Western Province',
    population: 326998,
    coordinates: [-1.9116, 29.4399],
    sectors: [
      { id: '72400831B82978257813376', name: 'Boneza', population: 22653 },
      { id: '72400831B27331980443351', name: 'Gihango', population: 22790 },
      { id: '72400831B57945311830710', name: 'Kigeyo', population: 22927 },
      { id: '72400831B70009683737019', name: 'Kivumu', population: 23064 },
      { id: '72400831B56533521071345', name: 'Manihira', population: 23201 },
      { id: '72400831B98557047493327', name: 'Mukura', population: 23338 },
      { id: '72400831B28578002137565', name: 'Murunda', population: 23475 },
      { id: '72400831B11553255040865', name: 'Musasa', population: 23612 },
      { id: '72400831B86668355700131', name: 'Mushonyi', population: 23749 },
      { id: '72400831B56711264517722', name: 'Mushubati', population: 23886 },
      { id: '72400831B81243699467508', name: 'Nyabirasi', population: 24023 },
      { id: '72400831B11601884019598', name: 'Ruhango', population: 24160 },
      { id: '72400831B41469838536911', name: 'Rusebeya', population: 24297 }
    ]
  }
]

export const rwandaProvinces = [
  'Kigali City',
  'Northern Province',
  'Southern Province',
  'Eastern Province',
  'Western Province'
]

// Helper functions for geographic data
export const getDistrictByName = (name) => {
  return rwandaDistricts.find(district =>
    district.name.toLowerCase() === name.toLowerCase()
  )
}

export const getSectorsByDistrict = (districtId) => {
  const district = rwandaDistricts.find(d => d.id === districtId)
  return district ? district.sectors : []
}

export const getAllSectors = () => {
  return rwandaDistricts.flatMap(district =>
    district.sectors.map(sector => ({
      ...sector,
      district: district.name,
      districtId: district.id,
      province: district.province
    }))
  )
}

export const getDistrictsByProvince = (province) => {
  return rwandaDistricts.filter(district => district.province === province)
}

// Population statistics
export const getTotalPopulation = () => {
  return rwandaDistricts.reduce((total, district) => total + district.population, 0)
}

export const getPopulationByProvince = () => {
  const provinceStats = {}
  rwandaDistricts.forEach(district => {
    if (!provinceStats[district.province]) {
      provinceStats[district.province] = 0
    }
    provinceStats[district.province] += district.population
  })
  return provinceStats
}
